import {GOOGLE_ANALYTICS_EVENTS, HUBSPOT} from './constants';
import isHubspotForm from './utils/isHubspotForm';

export const formStartCallback = ({target: {form}}) => {
  if ((!form) instanceof HTMLFormElement) return;

  const {formId, started} = form.dataset;

  if (started === 'true') return;

  window.dataLayer.push({
    event: GOOGLE_ANALYTICS_EVENTS.FORM_START,
    form_id: formId,
    form_host: HUBSPOT,
  });

  // mark form started to prevent duplicate `form_start` event push
  form.dataset.started = true;
};

const registerHubspotFormStart = form => {
  if (!isHubspotForm(form)) return;

  const hsInputs = form.querySelectorAll('.hs-input:not([type="hidden"])');

  hsInputs.forEach(hsInput => {
    hsInput.addEventListener('input', formStartCallback);
  });
};

export default registerHubspotFormStart;
